var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.99992H15V7.99992H18V9.99992ZM18 13.9999H15V11.9999H18V13.9999ZM13 9.99992H10V7.99992H13V9.99992ZM13 13.9999H10V11.9999H13V13.9999ZM8 9.99992H5V7.99992H8V9.99992ZM8 13.9999H5V11.9999H8V13.9999ZM19 5.99992H4V2.49992C4 2.18492 3.852 1.88892 3.6 1.69992L1.6 0.199918C1.297 -0.027082 0.892 -0.064082 0.553 0.105918C0.214 0.274918 0 0.620918 0 0.999918V14.9999C0 15.5519 0.448 15.9999 1 15.9999H19C19.552 15.9999 20 15.5519 20 14.9999V6.99992C20 6.44792 19.552 5.99992 19 5.99992Z",
    fill: "#7C90B1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSites);
export default __webpack_public_path__ + "static/media/sites.4fdff4af.svg";
export { ForwardRef as ReactComponent };